'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _branch = require('recompose/branch');

var _branch2 = _interopRequireDefault(_branch);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var renderSelf = function renderSelf(component) {
  return component;
};
var renderNull = function renderNull() {
  return function () {
    return null;
  };
};

exports.default = function (checkReady) {
  return (0, _branch2.default)(checkReady, renderSelf, renderNull);
};


//////////////////
// WEBPACK FOOTER
// ./~/coact-utils/renderAfter.js
// module id = 1064
// module chunks = 0